import {
  BenchmarkStatistics,
  DroppedReason,
  FunnelPerStageStatistics,
  MonthlyStatistics,
  Statistics,
} from '@tassomutuo-backoffice/types';
import { useState } from 'react';
import { Box } from '@mui/material';
import DashboardLostRevenueChart from './DashboardLostRevenueChart';

export type CardOptions =
  | 'receivedLeads'
  | 'estimatedMortgages'
  | 'conversionRate'
  | 'estimatedRevenue'
  | 'revenuePerLead'
  | 'effectiveRevenue'
  | 'lostRevenue';

interface DashboardContentProps {
  isTeamStatistics?: boolean;
  statisticsAllPeriod?: Statistics;
  statisticsAllPeriodTrend?: Statistics;
  statisticsPerMonth?: MonthlyStatistics;
  funnelPerStageStatistics?: FunnelPerStageStatistics;
  benchmarkStatistics?: BenchmarkStatistics;
  showAllCharts?: boolean;
  isPrinting?: boolean;
  droppedReasons?: DroppedReason;
}

const DashboardContent = ({
  isTeamStatistics,
  statisticsAllPeriod,
  statisticsPerMonth,
  funnelPerStageStatistics,
  benchmarkStatistics,
  statisticsAllPeriodTrend,
  showAllCharts,
  isPrinting,
  droppedReasons,
}: DashboardContentProps) => {
  const [selectedCard] = useState<CardOptions>('receivedLeads');

  return (
    <>
      {/* {statisticsAllPeriod && (
        <Box sx={{ pb: isPrinting ? 7 : 0 }}>
          <DashboardStatisticsAllPeriod
            statistics={statisticsAllPeriod}
            statisticsTrend={statisticsAllPeriodTrend}
            selectedCard={selectedCard}
            onChangeCard={setSelectedCard}
          />
        </Box>
      )} */}

      {statisticsPerMonth && (
        <>
          {(selectedCard === 'receivedLeads' || showAllCharts) && (
            <Box sx={{ pb: isPrinting ? 13 : 0 }}>
              {!isPrinting && (
                <DashboardLostRevenueChart
                  statisticsPerMonth={statisticsPerMonth}
                  isPrinting={isPrinting}
                />
              )}
            </Box>
          )}          
          {(selectedCard === 'lostRevenue' || showAllCharts) && (
            <Box sx={{ pb: isPrinting ? 28 : 0 }}>
              <DashboardLostRevenueChart
                statisticsPerMonth={statisticsPerMonth}
                isPrinting={isPrinting}
              />
            </Box>
          )}
          {/* <DashboardStaticsPerMonths statisticsPerMonth={statisticsPerMonth} />*/}
        </>
      )}

      
    </>
  );
};

export default DashboardContent;
